import Calculators from './Calculators';
import { TripleRefoundCalculator } from '@vilibets/vilibets-uikit/dist/molecules/Calculators/Calculators';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const TripleRefoundCalc = () => {
  // get params from url
  const [searchParams, setSearchParams] = useSearchParams();
  // get searchParams and set it to initialParams
  const initialParams = () => {
    let params = {};
    for (const [key, value] of searchParams) {
      params = { ...params, [key]: value };
    }
    if (!('retencion' in params)) {
      params.retencion = '75.00';
    }
    return params;
  };

  useEffect(() => {
    const d = document.querySelector('[title="Retención del Importe de Reembolso"]');
    d.style.textAlign = 'right';
  });
  return (
    <Calculators>
      <TripleRefoundCalculator
        initialParams={initialParams}
        onChange={(params) => {
          setSearchParams(params);
        }}
      />
    </Calculators>
  );
};

export default TripleRefoundCalc;
